{
  "version": 1,
  "asset_id": "7f29eece-93f5-4cb3-a1de-6f5cbb4599f8",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/7f29eece-93f5-4cb3-a1de-6f5cbb4599f8/clip-img_2346.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/7f29eece-93f5-4cb3-a1de-6f5cbb4599f8/clip-img_2346.mp4",
  "original_filename": "clip-img_2346.mp4",
  "size": 414681,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:33:08Z"
}
